import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { PrimitiveAtom } from "jotai";

import { InnerWrapper, PLANOGRAM_LAYER_Z_INDEX } from "../../common/InnerWrapper";
import { Scaleable } from "../../store/types";
import { Bay } from "./Bay";
import { Pegboard } from "../Pegboards/Pegboard";
import { Pegboards } from "../Pegboards/Pegboards";
import { PlanogramBay } from "@CommonTypes/merchflow/pog/bay";
import styled from "styled-components";
import { createSyntheticHangcellPegboard } from "../Shelf/hangcellPegboard";

const BayPegboardsLayer = styled.div<{ $zIndex: number }>`
  position: absolute;
  inset: 0;
  z-index: ${({ $zIndex }) => $zIndex};
  pointer-events: none;
`;

interface Props extends Scaleable {
  bays: PlanogramBay[];
  isEditable: boolean;
  highlightedItems: string[];
  pogAtom: PrimitiveAtom<Pog>;
  pdfMode?: boolean;
  pdfNotchRulerWidth?: number;
}

export const Bays = ({
  bays,
  scaleX,
  scaleY,
  isEditable,
  highlightedItems,
  pogAtom,
  pdfMode,
  pdfNotchRulerWidth,
}: Props) => (
  <InnerWrapper className="bays" $zIndex={PLANOGRAM_LAYER_Z_INDEX.bays}>
    {bays.map((bay, bayNo) => {
      const syntheticHangcellShelves = bay.shelves.filter((shelf) => shelf.type === "HANGCELL");

      return (
        <Bay
          key={bayNo}
          bay={bay}
          scaleX={scaleX}
          scaleY={scaleY}
          isEditable={isEditable}
          pogAtom={pogAtom}
          pdfMode={pdfMode}
          pdfNotchRulerWidth={pdfNotchRulerWidth}
        >
          {syntheticHangcellShelves.length > 0 && (
            <BayPegboardsLayer className="bay-synthetic-pegboards" $zIndex={0}>
              {syntheticHangcellShelves.map((shelf) => (
                <Pegboard
                  key={`${shelf.uniqueId}-pegboard`}
                  pegboard={createSyntheticHangcellPegboard(shelf)}
                  pegboardWidth={shelf.width}
                  xLeft={shelf.getXLeft() - bay.getXLeft()}
                  scaleX={scaleX}
                  scaleY={scaleY}
                  highlightedItems={highlightedItems}
                  pogAtom={pogAtom}
                />
              ))}
            </BayPegboardsLayer>
          )}

          <BayPegboardsLayer className="bay-pegboards" $zIndex={1}>
            <Pegboards
              pegboards={bay.pegboards || []}
              width={bay.width}
              scaleX={scaleX}
              scaleY={scaleY}
              highlightedItems={highlightedItems}
              pogAtom={pogAtom}
            />
          </BayPegboardsLayer>
        </Bay>
      );
    })}
  </InnerWrapper>
);
